import { omit } from 'lodash'

import globalApi from '@/request/globalApi/globalApi'
import { fireDeleteAlert } from '@/request/globalApi/interceptors/globalApiRequestDeleteInterceptor'
import axios from 'axios'

export const END_POINT = 'api/organization'

// ORGANIZATION
export const fetchOrganizationRequest = (organizationId, params) => globalApi.get(`${END_POINT}/${organizationId}`, { params })

export const fetchEligibleMFCOrganizationsRequest = (params = {}) => globalApi.get('api/organizations/eligible', { params })

export const fetchOrganizationsRequest = params => globalApi.get(END_POINT, { params })

export const deleteOrganizationRequest = organizationId => globalApi.delete(`${END_POINT}/${organizationId}/delete`)

// USERS
export const fetchOrganizationUsersRequest = (organizationId, params) => globalApi.get(`${END_POINT}/${organizationId}/user`, { params })

export const fetchOrganizationUserRequest = (organizationId, organizationUserId) => globalApi.get(`${END_POINT}/${organizationId}/user/${organizationUserId}`)

export const postOrganizationUserRequest = (organizationId, organizationUser, message) => globalApi.post(`${END_POINT}/${organizationId}/user`, organizationUser, { message })

export const patchOrganizationUserRequest = (organizationId, organizationUser, message) => globalApi.patch(`${END_POINT}/${organizationId}/user/${organizationUser.id}`, omit(organizationUser, 'id'), { message })

export const patchOrganizationUserNewInvitationRequest = (organizationId, organizationUserId, data) => globalApi.patch(`${END_POINT}/${organizationId}/user/${organizationUserId}/new-invitation`, data)

export const deleteOrganizationUserRequest = (organizationId, organizationUserId, message) => fireDeleteAlert().then(
  isConfirmed => isConfirmed && globalApi.delete(`${END_POINT}/${organizationId}/user/${organizationUserId}`, { message }),
)
// RIGHTS
export const fetchOrganizationRightsRequest = organizationId => globalApi.get(`${END_POINT}/${organizationId}/rights`)

// INFORMATIONS
export const fetchOrganizationInfosRequest = organizationId => globalApi.get(`${END_POINT}/${organizationId}/infos`)

export const patchOrganizationInfosRequest = (organizationId, organizationInfos, message) => globalApi.patch(`${END_POINT}/${organizationId}/infos`, organizationInfos, { message })

// LEGALS
export const fetchOrganizationLegalRequest = organizationId => globalApi.get(`${END_POINT}/${organizationId}/legal`)

export const patchOrganizationLegalRequest = (organizationId, organizationLegal, message) => globalApi.patch(`${END_POINT}/${organizationId}/legal`, organizationLegal, { message })

// OFFER
export const fetchOrganizationOfferRequest = organizationId => globalApi.get(`${END_POINT}/${organizationId}/offer`)

// MFC2-1631 — offres soumises en attente d'acceptation (alerte post-connexion) : { hasPendingOffers, offersToken }
export const fetchOrganizationPendingOffersRequest = organizationId => globalApi.get(`${END_POINT}/${organizationId}/pending-offers`)

export const fetchOrganizationPaymentsRequest = (organizationId, params) => globalApi.get(`${END_POINT}/${organizationId}/offer-payments`, { params })

export const patchOrganizationOfferRequest = (organizationId, offersIds, message) => globalApi.patch(`${END_POINT}/${organizationId}/submit-offer`, offersIds, { message })

// PRESENTATION
export const fetchOrganizationPresentationRequest = organizationId => globalApi.get(`${END_POINT}/${organizationId}/presentation`)

export const patchOrganizationPresentationRequest = (organizationId, organizationPresentation, message) => globalApi.patch(`${END_POINT}/${organizationId}/presentation`, organizationPresentation, { message })

// ACCOUNTING
export const fetchOrganizationAccountingRequest = (organizationId, params) => globalApi.get(`${END_POINT}/${organizationId}/accounting`, { params })
export const fetchOrganizationInvoiceConfigurationRequest = organizationId => globalApi.get(`${END_POINT}/${organizationId}/invoice-configuration`)
export const editOrganizationInvoiceConfigurationRequest = (organizationId, invoiceConfiguration, message) => globalApi.patch(`${END_POINT}/${organizationId}/invoice-configuration`, invoiceConfiguration, { message })

// PAYMENT
export const fetchOrganizationPaymentRequest = (organizationId, params) => globalApi.get(`${END_POINT}/${organizationId}/payment`, { params })
export const fetchOrganizationBalanceRequest = organizationId => globalApi.get(`${END_POINT}/${organizationId}/balance`)

// ADDRESSES
export const fetchOrganizationAdressesRequest = (organizationId, params) => globalApi.get(`${END_POINT}/${organizationId}/address`, { params })

export const postOrganizationAddressRequest = (organizationId, organizationAddress, message) => globalApi.post(`${END_POINT}/${organizationId}/address`, organizationAddress, { message })

export const patchOrganizationAddressRequest = (organizationId, organizationAddress, message) => globalApi.patch(`${END_POINT}/${organizationId}/address/${organizationAddress.address.id}`, organizationAddress, { message })

export const deleteOrganizationAddressRequest = (organizationId, organizationAddressId, message) => fireDeleteAlert().then(
  isConfirmed => isConfirmed && globalApi.delete(`${END_POINT}/${organizationId}/address/${organizationAddressId}`, { message }),
)
// AIRPORTS
export const fetchOrganizationAirportsRequest = (organizationId, params) => globalApi.get(`${END_POINT}/${organizationId}/airports`, { params })

export const patchOrganizationAirportsRequest = (organizationId, organizationAirports, message) => globalApi.patch(`${END_POINT}/${organizationId}/airports`, organizationAirports, { message })

// CONTACT
export const postOrganizationContactRequest = (organizationId, content, message) => globalApi.post(`${END_POINT}/${organizationId}/contact`, content, { message })

// KYC
export const fetchOrganizationKYCAccountLinkRequest = (organizationId, params) => globalApi.get(`${END_POINT}/${organizationId}/kyc-account-link`, { params })

export const fetchOrganizationKYCRequest = organizationId => globalApi.get(`${END_POINT}/${organizationId}/kyc`)

export const patchOrganizationKYCRequest = (organizationId, organizationKYC, message) => globalApi.patch(`${END_POINT}/${organizationId}/kyc`, organizationKYC, { message })

// EXTERNAL ACCOUNT
export const fetchOrganizationExternalAccountsRequest = organizationId => globalApi.get(`${END_POINT}/${organizationId}/external-account`)

export const fetchOrganizationExternalAccountRequest = (organizationId, externalAccountId) => globalApi.get(`${END_POINT}/${organizationId}/external-account/${externalAccountId}`)

export const postOrganizationExternalAccountRequest = (organizationId, externalAccount, message) => globalApi.post(`${END_POINT}/${organizationId}/external-account`, externalAccount, { message })

export const patchOrganizationExternalAccountRequest = (organizationId, externalAccount, message) => globalApi.patch(`${END_POINT}/${organizationId}/external-account/${externalAccount.id}`, externalAccount, { message })

export const deleteOrganizationExternalAccountRequest = (organizationId, externalAccountId, message) => fireDeleteAlert().then(
  isConfirmed => isConfirmed && globalApi.delete(`${END_POINT}/${organizationId}/external-account/${externalAccountId}`, { message }),
)

// LEON INTEGRATION
export const LEON_END_POINT = 'api/leon'

export const leonConnectionStateRequest = organizationId => globalApi.get(`${LEON_END_POINT}/connection-state/${organizationId}`)

export const leonChangeActivationRequest = organizationId => globalApi.patch(`${LEON_END_POINT}/change-activation/${organizationId}`)

export const leonDeleteTokenRequest = organizationId => globalApi.delete(`${LEON_END_POINT}/delete-token/${organizationId}`)

export const leonConnectRequest = (leonOprId, redirectUri) => globalApi.get(`${LEON_END_POINT}/connect/${leonOprId}`, { params: { redirect_uri: redirectUri } })

export const leonReconnectRequest = (leonOprId, redirectUri) => globalApi.get(`${LEON_END_POINT}/reconnect/${leonOprId}`, { params: { redirect_uri: redirectUri } })

export const leonCreateTokensRequest = (oprId, code) => globalApi.get(`${LEON_END_POINT}/create-tokens/${oprId}`, { params: { code } })

export const leonInvitationRequest = (organizationId, data) => globalApi.patch(`${LEON_END_POINT}/invitation/${organizationId}`, data)

// AIRPORT CHARGES (RDC) INTEGRATION
export const AIRPORT_CHARGES_END_POINT = 'api/airport-charges'

export const airportChargesStateRequest = organizationId => globalApi.get(`${AIRPORT_CHARGES_END_POINT}/configuration-state/${organizationId}`)

export const airportChargesSaveTokenRequest = (organizationId, data) => globalApi.post(`${AIRPORT_CHARGES_END_POINT}/save-token/${organizationId}`, data)

export const airportChargesChangeActivationRequest = organizationId => globalApi.patch(`${AIRPORT_CHARGES_END_POINT}/change-activation/${organizationId}`)

export const airportChargesDeleteTokenRequest = organizationId => globalApi.delete(`${AIRPORT_CHARGES_END_POINT}/delete-token/${organizationId}`)

// TODO: create instance for download
export const downloadAccountingCSV = organizationId => {
  const token = `Bearer ${localStorage.getItem('token')}` || ''
  const selectedOrganizationId = localStorage.getItem('selectedOrganization')
        && JSON.parse(localStorage.getItem('selectedOrganization')).id
  const lang = localStorage.getItem('lang')

  axios.get(`${process.env.VUE_APP_API_BASE_URL}${END_POINT}/${organizationId}/accounting-export`, {
    headers: { Accept: 'text/csv', 'Content-Type': 'text/csv', Authorization: token, selectedOrganizationId, lang },
  }).then(response => {
    const blob = new Blob(
      [response.data],
      { type: 'text/csv' },
    )
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = 'export.csv' // TODO dynamic name when instance created
    link.click()
  })
}
/**
 * Envoie une requête pour générer une nouvelle clé API pour une organisation.
 * @param {string|number} organizationId - L'ID de l'organisation.
 * @returns {Promise<Object>} La réponse de l'API contenant la nouvelle clé.
 */
export const generateApiKeyRequest = organizationId => globalApi.post(`/api/organizations/${organizationId}/generate-api-key`)

export function deleteApiKeyRequest(orgId) {
  return globalApi.delete(`/api/organizations/${orgId}/api-keys/last`)
}

/**
 * Met à jour le statut (activé/désactivé) de la clé API d'une organisation.
 * @param {string|number} organizationId - L'ID de l'organisation.
 * @param {object} payload - Le corps de la requête, ex: { isActive: true }
 * @returns {Promise<Object>} La réponse de l'API.
 */
export const updateApiKeyStatusRequest = (organizationId, payload) => globalApi.put(`/api/organizations/${organizationId}/api-keys`, payload)

export function updateApiKeyLastRequest(orgId, body) {
  return globalApi.patch(`/api/organizations/${orgId}/api-keys/last`, body)
}
